import { Redirect, Route, Switch } from "react-router-dom";
import { Flow } from "../../../../../shared/components/Flow";
import { StepAbout } from "./StepAbout";
import { StepHowItWorks } from "./StepHowItWorks";
import { StepCertify } from "./StepCertify";
import { useQueryPlanEnrollments } from "../../../../../query/benefits/useQueryPlanEnrollments";
import { WSQueries } from "../../../../../query/WSQuery";
import { getOAIBenefitListItem } from "../../../components/customBenefits/OAI/getOAIBenefitListItem";
import { selectorAvailablePlanEnrollments } from "../../../selectors/selectorAvailablePlanEnrollments";
import { useGetNow } from "../../../../../shared/hooks/useGetNow";
import { FlowStepStatus } from "../../../../../shared/components/FlowSwitch/types";

export const EnrollOAI: React.FC<{
  basePath: string;
  goBack(): void;
}> = props => {
  const { goBack, basePath } = props;

  const now = useGetNow();

  const qPlanEnrollments = useQueryPlanEnrollments({
    filter: {
      planType: "WingspanOccupationalAccidentInsurance"
    },
    sort: "createdAt"
  });

  return (
    <WSQueries queries={{ qPlanEnrollments }}>
      {({ qPlanEnrollmentsData }) => {
        const planEnrollment = selectorAvailablePlanEnrollments(
          qPlanEnrollmentsData,
          now
        ).find(Boolean);

        const isCompleted =
          planEnrollment?.status === "Active" ||
          planEnrollment?.status === "Terminated";
        const isPending = planEnrollment?.status === "Pending";

        const status: FlowStepStatus = isCompleted
          ? "Complete"
          : isPending
            ? "Pending"
            : "None";

        return (
          <Switch>
            <Route
              path={basePath}
              render={() => (
                <Flow
                  title="Insurance enrollment"
                  basePath={basePath}
                  hideNavigation={isCompleted || isPending}
                  steps={[
                    {
                      slug: "steps",
                      title: getOAIBenefitListItem().name,
                      steps: [
                        {
                          slug: "intro",
                          title: "Intro",
                          component: StepAbout
                        },
                        {
                          slug: "how-it-works",
                          title: "How it works",
                          component: StepHowItWorks
                        },
                        {
                          slug: "subscription",
                          title: "Certify & enroll",
                          component: StepCertify
                        }
                      ],
                      status: status,

                      result: {
                        Complete: {
                          description: (
                            <>
                              Congrats! You’re now covered under Wingspan Master
                              Policy for Occupational Accident Insurance.
                            </>
                          ),
                          title: "Your enrollment was successful!"
                        },
                        Pending: {
                          description: (
                            <>
                              Your enrollment is pending. Please check back
                              later.
                            </>
                          ),
                          title: "Your enrollment is pending"
                        }
                      }
                    }
                  ]}
                  onBack={goBack}
                  onNext={goBack}
                />
              )}
            />

            <Redirect from="*" to={basePath} />
          </Switch>
        );
      }}
    </WSQueries>
  );
};
